import { TextField, ListItemIcon, ListItem, Stack, Box } from '@mui/material';

interface InputFieldProps {
  inputValue?: string;
  fieldName?: string;
  icon: any;
  handleFieldChange?: (e: any) => void;
  isPassword?: boolean;
  isDate?: boolean;
  endAdornment?: React.JSX.Element;
  selectComp?: any;
  label?: string;
  isGender?: boolean;
  placeholder?: string;
  fieldsDisabled?: boolean;
  open?: () => void;
  isReadOnly?: boolean;
  additionalComp?: React.JSX.Element;
  disableGutters?: boolean;
  error?: boolean;
  helperText?: string;
}

export function InputField(props: InputFieldProps) {
  const {
    inputValue,
    icon,
    fieldName,
    label,
    handleFieldChange,
    isPassword,
    endAdornment,
    isGender,
    selectComp,
    placeholder,
    additionalComp,
    isReadOnly,
    fieldsDisabled,
    open,
    disableGutters = false,
    isDate,
    error,
    helperText,
  } = props;

  return (
    <ListItem disableGutters={disableGutters}>
      <ListItemIcon sx={{ color: 'secondary.main', paddingTop: '15px' }}>{icon}</ListItemIcon>
      <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ width: '100%' }}>
        <TextField
          sx={{ width: '100%' }}
          onClick={() => isReadOnly && !fieldsDisabled && open()}
          select={isGender ? true : false}
          type={isPassword ? 'password' : isDate ? 'date' : 'text'}
          name={fieldName}
          label={label}
          placeholder={placeholder}
          value={inputValue}
          onChange={handleFieldChange}
          disabled={fieldsDisabled}
          error={error}
          helperText={helperText}
          slotProps={{
            input: { readOnly: isReadOnly, endAdornment: endAdornment },
            inputLabel: isDate ? { shrink: true } : undefined,
          }}
          variant="standard"
        >
          {selectComp}
        </TextField>
        <Box sx={{ ml: { xs: 0, sm: '10px' }, mt: { xs: '10px', sm: 0 } }}>{additionalComp}</Box>
      </Stack>
    </ListItem>
  );
}
